import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=2723bfc1&scoped=true"
import script from "./LogoutDialog.vue?vue&type=script&lang=js"
export * from "./LogoutDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723bfc1",
  null
  
)

export default component.exports